/** Fasce orarie di una giornata come arrivano dal backend ('HH:mm:ss', null se assenti). */
export interface FasceOrarie {
  startTime1?: string | null;
  endTime1?: string | null;
  startTime2?: string | null;
  endTime2?: string | null;
}

const getOra = (ora: string): string => ora.slice(0, 5);

// Fascia vuota se manca un estremo o se inizio = fine (es. 00:00-00:00).
const getFascia = (
  inizio?: string | null,
  fine?: string | null
): string | null => {
  if (!inizio || !fine || inizio === fine) return null;
  return `${getOra(inizio)}-${getOra(fine)}`;
};

// Fasce valide della giornata, nell'ordine, come "09:00-13:00"; vuoto se nessuna.
const getFasceValide = (fasce?: FasceOrarie | null): string[] =>
  fasce
    ? [
        getFascia(fasce.startTime1, fasce.endTime1),
        getFascia(fasce.startTime2, fasce.endTime2),
      ].filter((fascia): fascia is string => fascia !== null)
    : [];

/**
 * Fasce valide come "09:00-13:00, 15:00-19:00"; null se non ce n'è nessuna.
 * `separatore` cambia il testo fra le due fasce (nelle chip della fascia Presenze
 * « / », perché la virgola separa il tipo dall'orario).
 */
export const formatFasceOrarie = (
  fasce?: FasceOrarie | null,
  separatore = ', '
): string | null => {
  const valide = getFasceValide(fasce);
  return valide.length > 0 ? valide.join(separatore) : null;
};

/**
 * true se le fasce di una persona sono quelle del punto vendita nel giorno (per
 * «Orario negozio» nelle chip della fascia Presenze): stesse fasce valide, in
 * 'HH:mm', in qualunque ordine arrivino. La risposta «in servizio» è già incrociata
 * con l'orario del negozio. Senza orari del negozio per il giorno (non ancora
 * arrivati, in errore o negozio chiuso) false: la chip mostra l'orario, mai un
 * «Orario negozio» non verificato.
 */
export const isOrarioNegozio = (
  fasce: FasceOrarie,
  orarioNegozio: FasceOrarie | null | undefined
): boolean => {
  const negozio = getFasceValide(orarioNegozio).sort();
  const persona = getFasceValide(fasce).sort();
  return (
    negozio.length > 0 &&
    negozio.length === persona.length &&
    negozio.every((fascia, i) => fascia === persona[i])
  );
};
